// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartGridSeparator.jsx" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartGridSeparator component
 */
!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var CollapsibleList = require('share/components/controls/Izenda.CollapsibleList');
  var ReportPartTitle = require('../FieldContainers/Izenda.ReportPartTitle');
  var ProcessDataUtils = require('share/utils/Izenda.ProcessDataUtils');
  var constants = require('logic/data/Izenda.ReportPartGridConstants');
  var SupReportLink = require('./Izenda.SubReportLink');
  var stylingUtil = require('./Izenda.ReportPartGridStylingUtil');
  var ReportPartUtils = require('share/utils/Izenda.ReportPartUtils');
  var PrintingUtils = require('share/utils/Izenda.PrintingUtils');
  var REPORT_PART_MODE = require('logic/data/Izenda.ReportBodyConstants').REPORT_PART_MODE;
  var COLLAPSE_STATUS = constants.COLLAPSE_STATUS;
  var CUSTOM_FORMAT_PREFIX = require('logic/data/Izenda.ReportPartChartConstants').CUSTOM_FORMAT_PREFIX;
  const { map, concat, isEmpty, omit, get, sortBy, take, isNil, head } = require('lodash/fp');
  var SeparatorItem = function(props) {
    var separatorContent = props.separatorContent;
    var separatorStyle = props.separatorStyle;
    var reportPart = props.reportPart;

    return (
      <div>
        <SeparatorHeader
          separatorStyle={separatorStyle}
          keyCollection={separatorContent.key}
          separatorContent={separatorContent}
          reportPart={reportPart}
          getFilterInfoForSubReport={props.getFilterInfoForSubReport}
          renderListeners={props.renderListeners}
        />
        <SeparatorBody {...props} staticRender={props.staticRender} />
      </div>
    );
  };

  var SeparatorBody = React.createClass({
    componentWillMount: function() {
      this.renderListeners = [];
    },

    componentDidMount: function() {
      var props = this.props;

      props.printingMode &&
        PrintingUtils.publishFinishedRender(this.renderListeners, function() {
          props.finishedRender && props.finishedRender();
        });
    },
    render: function() {
      var separatorContent = this.props.separatorContent;
      var props = this.props;
      var renderListeners = this.renderListeners;
      var currentKeyPath = map(function(item) {
        return { element: item.element, value: item.value };
      }, separatorContent.key);
      var subKeyPath = concat(props.keyPath || [], currentKeyPath);

      if (!isEmpty(separatorContent.subGroup)) {
        return (
          <div>
            {map(function(item) {
              var key = map('value', item.key).join('_');

              PrintingUtils.pushRenderListener(renderListeners, key);
              return (
                <SeparatorItem
                  {...props}
                  separatorContent={item}
                  key={key}
                  keyPath={subKeyPath}
                  staticRender={props.staticRender}
                  finishedRender={PrintingUtils.getFinishedRenderPromiseById(renderListeners, key)}
                />
              );
            }, separatorContent.subGroup)}
          </div>
        );
      }

      var keyString = JSON.stringify(subKeyPath);
      var separatorBodyKey = 'SeparatorBody.' + keyString;

      PrintingUtils.pushRenderListener(renderListeners, separatorBodyKey);

      var GridComponent = this.props.mainComponent;
      var records = separatorContent.data || separatorContent;
      var restProps = omit(['finishedRender'], this.props);

      // Add grid detail here
      return (
        <GridComponent
          {...restProps}
          records={records}
          keyPath={subKeyPath}
          staticRender={props.staticRender}
          finishedRender={PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorBodyKey)}
        />
      );
    }
  });

  var SeparatorHeaderItem = observer(
    React.createClass({
      componentDidMount: function() {
        var props = this.props;
        var item = props.item;
        var fieldElement = item.element;
        var numberOfPointActions = get('numberOfPointActions', fieldElement);

        !numberOfPointActions && props.printingMode && props.finishedRender && props.finishedRender();
      },
      render: function() {
        var props = this.props;
        var item = props.item;
        var separatorContent = props.separatorContent;
        var reportPart = props.reportPart;
        var rawRecord = separatorContent.data;
        var { originalValue } = ReportPartUtils.getFieldValue(item.columnName, head(rawRecord));
        var displayValue = getDisplayValueForHeader(item, originalValue, props.separatorStyle, separatorContent);
        var dataFormattingsStyles = stylingUtil.getDataFormattings(item.element, !isNil(originalValue) ? originalValue : item.value, rawRecord, reportPart);

        var fieldElement = item.element;
        var numberOfPointActions = get('numberOfPointActions', fieldElement);

        if (numberOfPointActions > 0) {
          return (
            <SupReportLink
              reportPart={reportPart}
              fieldElement={fieldElement}
              rawRecord={rawRecord}
              afterRenderCallBack={props.afterRenderCallBack}
              printingMode={props.printingMode}
              containerWidth={get('properties.dataFormattings.width.value', fieldElement)}
              getFilterInfoForSubReport={props.getFilterInfoForSubReport}
              finishedRender={props.finishedRender}
            >
              <span key={displayValue} style={dataFormattingsStyles}>
                {displayValue}
              </span>
            </SupReportLink>
          );
        }

        return (
          <span key={displayValue} style={dataFormattingsStyles} onClick={props.toggleCollapse}>
            {displayValue}
          </span>
        );
      }
    })
  );

  var SeparatorHeader = observer(
    React.createClass({
      componentWillMount: function() {
        this.renderListeners = [];
      },

      componentDidMount: function() {
        var props = this.props;

        props.printingMode &&
          PrintingUtils.publishFinishedRender(this.renderListeners, function() {
            props.finishedRender && props.finishedRender();
          });
      },

      render: function() {
        var props = this.props;
        var separatorStyle = props.separatorStyle;
        var keyCollection = props.keyCollection;
        var separatorContent = props.separatorContent;
        var reportPart = props.reportPart;
        var prevItem;
        var renderListeners = this.renderListeners;

        if (separatorStyle.multiLine) {
          return (
            <div className="header-group separator-title u_fullWidth">
              {map(function(item) {
                var keyString = JSON.stringify(item);
                var separatorHeaderKey = 'SeparatorHeader.' + keyString;

                PrintingUtils.pushRenderListener(renderListeners, separatorHeaderKey);

                return (
                  <div>
                    <SeparatorHeaderItem
                      item={item}
                      separatorStyle={separatorStyle}
                      separatorContent={separatorContent}
                      reportPart={reportPart}
                      toggleCollapse={props.toggleCollapse}
                      afterRenderCallBack={props.printingMode && props.afterRenderCallBack}
                      printingMode={props.printingMode}
                      getFilterInfoForSubReport={props.getFilterInfoForSubReport}
                      finishedRender={PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorHeaderKey)}
                    />
                  </div>
                );
              }, keyCollection)}
            </div>
          );
        }
        return (
          <div className="inline-block header-group separator-title u_fullWidth">
            {keyCollection.map(function(item, index) {
              var keyString = JSON.stringify(item);
              var separatorHeaderKey = 'SeparatorHeader.' + keyString;

              PrintingUtils.pushRenderListener(renderListeners, separatorHeaderKey);

              return (
                <span key={index}>
                  {getSeparatorSign(index, item)}
                  <SeparatorHeaderItem
                    item={item}
                    separatorStyle={separatorStyle}
                    separatorContent={separatorContent}
                    reportPart={reportPart}
                    toggleCollapse={props.toggleCollapse}
                    afterRenderCallBack={props.printingMode && props.afterRenderCallBack}
                    printingMode={props.printingMode}
                    getFilterInfoForSubReport={props.getFilterInfoForSubReport}
                    finishedRender={PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorHeaderKey)}
                  />
                </span>
              );
            })}
          </div>
        );

        /**
         * get separator sign (,) for each separator
         * @return {String} sign
         */
        function getSeparatorSign(index, item) {
          var isPrevItemVisible = prevItem && prevItem.element.properties.fieldItemVisible;

          prevItem = item;
          return isPrevItemVisible ? ', ' : '';
        }
      }
    })
  );

  var CollapsibleHeader = observer(function(props) {
    return (
      <section>
        <i className="icon-toggle-triangle collapse-icon" onClick={props.toggleCollapse} />
        <SeparatorHeader
          separatorStyle={props.separatorStyle}
          keyCollection={props.keyCollection}
          separatorContent={props.separatorContent}
          toggleCollapse={props.toggleCollapse}
          getFilterInfoForSubReport={props.getFilterInfoForSubReport}
          reportPart={props.reportPart}
        />
      </section>
    );
  });

  var ReportPartGridSeparator = React.createClass({
    createSeparatorList: function(reportPart) {
      var previewDataFieldsMapping = reportPart.previewDataFieldsMapping;

      return {
        separatorList: ProcessDataUtils.filterMappingByContainer(
          previewDataFieldsMapping,
          reportPart.reportPartContent.separators
        )
      };
    },
    getInitialState: function() {
      return this.createSeparatorList(this.props.reportPart);
    },
    componentWillReceiveProps: function(nextProps) {
      if (this.props.records !== nextProps.records) {
        this.setState(this.createSeparatorList(nextProps.reportPart));
      }
    },
    componentWillMount: function() {
      this.renderListeners = []; // for cells
    },

    componentDidMount: function() {
      var props = this.props;

      props.printingMode &&
        PrintingUtils.publishFinishedRender(this.renderListeners, function() {
          props.finishedRender && props.finishedRender();
        });
    },

    componentDidUpdate: function() {
      // Reset default collapse
      this.props.reportPart.reportPartContent.setCollapseStatus(COLLAPSE_STATUS.DEFAULT);
    },

    render: function() {
      var props = this.props;
      var records = props.records;
      var separatorList = sortBy('element.position', this.state.separatorList);
      var separatorStyle = props.reportPart.reportPartContent.separatorStyle;
      var convertData = ProcessDataUtils.splitDataForSeparator(records, separatorList, separatorStyle.multiLevel);

      if (props.isPreview) {
        convertData = take(constants.NUMBER_OF_PREVIEW_SEPARATOR, convertData);
      }

      return props.printingMode
        ? this.renderPrintingMode(convertData, separatorStyle)
        : this.renderNormalMode(convertData, separatorStyle);
    },

    expandAll: function() {
      var reportPartContent = this.props.reportPart.reportPartContent;
      reportPartContent.setCollapseStatus(COLLAPSE_STATUS.EXPAND);
      this.updateDrillDownRecords(reportPartContent.getDrilldownInfo(true));
    },

    collapseAll: function() {
      var reportPartContent = this.props.reportPart.reportPartContent;
      reportPartContent.setCollapseStatus(COLLAPSE_STATUS.COLLAPSE);
      this.updateDrillDownRecords(reportPartContent.getDrilldownInfo(false, COLLAPSE_STATUS.DEFAULT));
    },

    updateDrillDownRecords: function(drillDownOption) {
      var reportPart = this.props.reportPart;
      var loader = this.props.loader;
      loader.startLoading();
      this.props
        .getDrillDownRecords(reportPart, drillDownOption, reportPart.previewData.paging.pageIndex)
        .then(previewData => reportPart.setQueryData(previewData))
        .finally(loader.endLoading.bind(loader));
    },

    renderNormalMode: function(convertData, separatorStyle) {
      var props = this.props;
      var reportPart = props.reportPart;
      var localization = props.localization;
      var forDrillDown = reportPart.reportPartContent.gridStyle === constants.GRID_STYLES.DRILL_DOWN.value;

      return (
        <div>
          {forDrillDown && (
            <div>
              <span
                className="icon-plus-circled"
                title={localization.getText('REPORT_PART_GRID_CONSTANTS_LABEL_EXPAND_ALL_TOOLTIP')}
                onClick={this.expandAll}
              />
              <span
                className="icon-minus-circled"
                title={localization.getText('REPORT_PART_GRID_CONSTANTS_LABEL_COLLAPSE_ALL_TOOLTIP')}
                onClick={this.collapseAll}
              />
            </div>
          )}
          <CollapsibleList
            defaultExpand
            className="panel separator-grid"
            autoCollapse={false}
            afterToogleCallback={props.afterRenderCallBack}
          >
            {map(function(item) {
              var key = map('value', item.key).join('_');

              return (
                <CollapsibleList.Item key={key}>
                  <CollapsibleList.ItemHeader className="row panel-heading separator-header">
                    <CollapsibleHeader
                      key={key}
                      separatorStyle={separatorStyle}
                      keyCollection={item.key}
                      separatorContent={item}
                      getFilterInfoForSubReport={props.getFilterInfoForSubReport}
                      reportPart={reportPart}
                    />
                  </CollapsibleList.ItemHeader>
                  <CollapsibleList.ItemBody className="separator-body">
                    <SeparatorBody {...props} separatorContent={item} separatorStyle={separatorStyle} />
                  </CollapsibleList.ItemBody>
                </CollapsibleList.Item>
              );
            }, convertData)}
          </CollapsibleList>
        </div>
      );
    },

    renderPrintingMode: function(convertData, separatorStyle) {
      var props = this.props;
      var reportPart = props.reportPart;
      var usePageBreakAfterSeparator = reportPart.reportPartContent.usePageBreakAfterSeparator;
      var index = 0;
      var numOfRows = convertData && convertData.length;
      var renderListeners = this.renderListeners;

      return (
        <section className="printMode u-bgWhite">
          {map(function(item) {
            var elements = [];

            var header = {
              component: SeparatorHeader,
              separatorStyle: separatorStyle,
              keyCollection: item.key,
              separatorContent: item,
              reportPart: reportPart
            };

            var restProps = omit(['finishedRender'], props);
            var keyString = JSON.stringify(item.key);
            var separatorHeaderKey = 'SeparatorHeader.' + keyString;
            var separatorBodyKey = 'SeparatorBody.' + keyString;

            PrintingUtils.pushRenderListener(renderListeners, separatorHeaderKey);
            PrintingUtils.pushRenderListener(renderListeners, separatorBodyKey);

            elements.push(
              <div style={PrintingUtils.getSeparatorContainerStyle(props)}>
                <div className={PrintingUtils.getSeparatorClassName(props)}>
                  {usePageBreakAfterSeparator &&
                    index === 0 && (
                      <ReportPartTitle
                        mode={REPORT_PART_MODE.PREVIEW}
                        reportPart={reportPart}
                        className="u_marginBottom izenda-reportPartGrid_titl"
                      />
                    )}
                  <SeparatorHeader
                    separatorStyle={separatorStyle}
                    keyCollection={item.key}
                    separatorContent={item}
                    reportPart={reportPart}
                    printingMode
                    afterRenderCallBack={props.afterRenderCallBack}
                    getFilterInfoForSubReport={props.getFilterInfoForSubReport}
                    finishedRender={PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorHeaderKey)}
                  />
                  <SeparatorBody
                    {...restProps}
                    separatorContent={item}
                    separatorStyle={separatorStyle}
                    staticRender
                    finishedRender={PrintingUtils.getFinishedRenderPromiseById(renderListeners, separatorBodyKey)}
                  />
                </div>
              </div>
            );

            index < numOfRows - 1 && usePageBreakAfterSeparator && elements.push(<p className="pageBreak" />);

            index++;
            return elements;
          }, convertData)}
        </section>
      );
    }
  });

  /**
   * get display value for Separator Header
   * @param  {Object} item
   * @param  {any} originalValue
   * @param  {Object} separatorStyle
   * @param  {Object} separatorContent
   */
  function getDisplayValueForHeader(item, originalValue, separatorStyle, separatorContent) {
    var element = item.element;
    var fieldElementProperties = element.properties;
    var fieldItemVisible = fieldElementProperties.fieldItemVisible;
    var records = separatorContent.data || separatorContent;

    // return blank if this separator is invisible
    if (!fieldItemVisible) {
      return null;
    }
    var value = ReportPartUtils.getDataFormat(
      {
        value: item.value,
        originalValue
      },
      {
        alternativeText: get('dataFormattings.alternativeText', fieldElementProperties),
        fieldFormatData: get('dataFormattings.format.format', fieldElementProperties),
        fieldDataType: get('previewDataType', element)
      },
      {
        element: {
          columnName: item.columnName,
          reportPartElm: element
        },
        record: records[0]
      }
    );

    var displayValue = separatorStyle.withLabel
      ? String.format('{0}: {1}', get('field.fieldNameAlias', element), value)
      : value;

    return displayValue;
  }

  module.exports = observer(ReportPartGridSeparator);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.ReportPartGridSeparator.jsx